import { validate } from '@krugom/validator';
import store from '../../../store';
import { ApiRequest } from '../../../store/saga/api/actions';
import { requestParamsSchema } from '../../../components/CustomTag/CustomRequest/schema';
import { IApiRequestConfig } from '../../../store/saga/api/types';
import { isPlainObject } from 'lodash';

const requestTo = (arg?: any) => {
  if (!isPlainObject(arg)) {
    console.error('Request params must be an object');
    return;
  }
  const result = validate(arg, requestParamsSchema);
  if (!result.isValid) return;
  store.dispatch(ApiRequest(arg as IApiRequestConfig));
};

export default requestTo;
